import { OddsButton } from '@/components/widgets/odds-button';
import { useAccountInfo } from '@/hooks/query/account';
import { BetTypeContentProps } from '../bet-type-content';
import { BetChoices } from '@/types/bet-type-settings';
import { Fragment } from 'react';
import { useGetBetTypeSetting, useGetChoiceTitle } from '@/hooks';

export const BetTypeCol2ChoiceOptions = ({ matchModel, betTypeArray }: BetTypeContentProps) => {
	const market = betTypeArray[0];
	const { user } = useAccountInfo();
	const getBetTypeSetting = useGetBetTypeSetting();
	const betTypeId = betTypeArray[0].BetTypeId;
	const getChoiceTitle = useGetChoiceTitle(betTypeId);
	const { betChoices } = getBetTypeSetting(betTypeId, matchModel.GameID);
	const groupCount = 2;
	const filteredChoice = betChoices.filter(x => x.betTeam !== '');
	const groupChoices = filteredChoice.reduce((accumulator, currentValue, index) => {
		index % groupCount ? accumulator[accumulator.length - 1].push(currentValue) : accumulator.push([currentValue])
		// last group shoube be pad empty choice
		if (index === filteredChoice.length - 1) {
			const lastElement = accumulator[accumulator.length - 1];
			[...Array(groupCount - lastElement.length).keys()].forEach(_ => {
				lastElement.push({} as BetChoices)
			})
		}
		return accumulator;
	}, new Array<Array<BetChoices>>())

	return (
		<>
			<div className="bettype__content bettype__content--col-2">
				{
					groupChoices.map((group, index) => {
						return (
							<Fragment key={`${index}_${group[0].betTeam}`}>
								<div className="bettype__list">
									{
										group.map(choice => {
											return choice.label ?
												<div key={choice.betTeam} className="bettype__title">
													{
														getChoiceTitle({
															choice,
															market,
															match: matchModel
														})
													}
												</div> :
												<div key={choice.betTeam} className="bettype__title" />;
										})
									}
								</div>
								<div className="bettype__list">
									{
										group.map((choice, index) => {
											if (!choice.betTeam) {
												return <div key={index} />;
											}
											const line = choice.line ?
												market.Selections[choice.line].Price.toString() : '';
											return (
												<OddsButton
													key={`${market.Line}_${choice.betTeam}`}
													match={matchModel}
													market={market}
													selection={market.Selections[choice.betTeam]}
													homeTeamName={''}
													awayTeamName={''}
													goal={line}
													variant="vertical"
													betTeam={market.Selections[choice.betTeam].SelId}
													originalPrice={market.Selections[choice.betTeam].Price}
													sport={matchModel?.GameID}
													type="OU"
													oddsType={user?.OType}
													accountStatus={user?.ActStatus ?? 0}
												/>
											)
										})
									}
								</div>
							</Fragment>
						);
					})
				}
			</div>
		</>
	)
};
